import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';

const ReviewComplete = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleReturnHome = () => {
        localStorage.clear();
        navigate('/');
    };

    return (
        <section style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100%',
            padding: '20px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                width: '90%',
                maxWidth: '800px',
                textAlign: 'center',
                fontFamily: 'Merriweather',
                color: 'white',
                padding: '40px 20px',
                backgroundColor: '#7C112B',
                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.3)'
            }}>
                <div style={{
                    fontSize: '18px',
                    lineHeight: '1.8',
                    marginBottom: '40px',
                    whiteSpace: 'pre-wrap',
                    textAlign: 'left'
                }}>
                    {t('ReviewCompleteText')}
                </div>
                <button
                    onClick={handleReturnHome}
                    style={{
                        padding: "15px 40px",
                        borderRadius: "0px",
                        border: "2px solid #FDB933",
                        backgroundColor: "#FDB933",
                        color: "#7C112B",
                        fontFamily: "Merriweather",
                        fontSize: '16px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    {t('ReviewCompleteButton')}
                </button>
            </div>
        </section>
    );
};

export default ReviewComplete;

